import React from 'react';
import EventRegistrationContainer from '../../../Containers/AdminContainer/EventRegistration';
const EventRegistrationScreen = () => {
  return <EventRegistrationContainer />;
};

export default EventRegistrationScreen;
